import { useMutation } from '@tanstack/react-query'

import { generateShareLinkToAddCustomer } from '../functions/generateShareLinkToAddCustomer'

function useGenerateShareLinkToAddCustomer() {
  return useMutation(generateShareLinkToAddCustomer)
}

export { useGenerateShareLinkToAddCustomer }
